/**
 * Dashboard Page
 * @see Sprint 28 - Dashboard
 */

import { useState } from 'react';
import { PageHeader, Select } from '@/components/ui';
import {
  QuickActions,
  DashboardKPIs,
  MarketBreakdown,
  LowStockAlerts,
  PendingOrdersList,
  PendingTransfersList,
} from '@/features/dashboard';
import type { DashboardPeriod } from '@/features/dashboard';

const PERIOD_OPTIONS = [
  { value: '7days', label: '7 jours' },
  { value: '30days', label: '30 jours' },
  { value: 'month', label: 'Mois en cours' },
];

export default function DashboardPage() {
  const [period, setPeriod] = useState<DashboardPeriod>('7days');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <PageHeader
          title="Dashboard"
          subtitle="Vue d'ensemble de votre activite et stocks"
        />
        <Select
          value={period}
          onChange={(v) => setPeriod(v as DashboardPeriod)}
          options={PERIOD_OPTIONS}
          className="w-44"
        />
      </div>

      <QuickActions />

      <DashboardKPIs period={period} />

      <MarketBreakdown />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <LowStockAlerts />
        </div>
        <div className="lg:col-span-1">
          <PendingOrdersList />
        </div>
      </div>

      <PendingTransfersList />
    </div>
  );
}
